import React, { useState } from "react";
import "./campaigncard.css";
import TriggerModal from "./TriggerModal";

const formatDate = (isoString) => {
  const date = new Date(isoString);

  const options = { day: "numeric", month: "short", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-GB", options);

  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";

  return `${formattedDate.replace(/ /, 'th ')} ${hours}:${minutes} ${ampm}`;
};



const TriggerCard = ({cardData}) => {
  const [triggerModal, setTriggerModal] = useState(false);

  const toggleTriggerModal = () => {
    setTriggerModal(!triggerModal);
  };

  return (
    <>
      <div className="campaign-card card--gameboard-card item-card">
        <div className="line-after"></div>
        <div className="campaign-card__header">
          <div className="campaign-card__title-wrapper">
            <span className="details-icon">
              <svg
                width="16"
                height="23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="icon__svg"
                preserveAspectRatio="xMidYMid meet"
                style={{ width: "20px", height: "20px" }}
              >
                <path
                  d="M3.003 0a.5.5 0 00-.373.832L6.268 4.67 1.142 6.642a1 1 0 00-.4 1.584l5.11 5.961-2.12.59a.751.751 0 00.017 1.45l6.5 1.75a.738.738 0 00.666-.154.75.75 0 00.264-.63l-.5-6.5a.749.749 0 00-1.399-.315L8.525 12l-2.48-3.15 5.315-2.002a.999.999 0 00.387-1.597L7.417.504A1.5 1.5 0 006.294 0H3.003zm12.12 12.573a.75.75 0 00-.406.11c-.782.463-1.299 1.002-1.577 1.585a2.615 2.615 0 00-.194 1.667c.074.346.222.584.357.83-1.109.76-1.584 1.775-1.608 2.62-.82-.21-1.926-.034-2.963.821-.2-.198-.387-.406-.7-.572a2.614 2.614 0 00-1.655-.276c-.637.107-1.297.454-1.958 1.078a.751.751 0 101.028 1.091c.504-.474.894-.642 1.178-.69.284-.047.494.01.702.121.417.222.702.673.702.673a.75.75 0 001.221.113c.917-1.073 1.546-1.05 2.081-.907.535.142.91.51.91.51a.75.75 0 001.189-.894s-.25-.462-.24-1.015c.012-.553.163-1.165 1.448-1.75a.75.75 0 00.228-1.204s-.354-.399-.452-.861a1.03 1.03 0 01.08-.708c.123-.26.391-.589.987-.941a.75.75 0 00-.358-1.4z"
                  fill="#29353D"
                ></path>
              </svg>
            </span>
            <div className="campaign-card__title">Trigger</div>
          </div>
        </div>
        <div className="campaign-card__content">
          <div className="card--item--type">Fixed Time</div>
          <div className="campaign-card--description details">
            {/* 28th Feb 2025, 10:20 AM */}
            {!formatDate(cardData?.trigger?.trigger_date).includes('NaN') ? formatDate(cardData?.trigger?.trigger_date) : ""}
          </div>
        </div>
        <div className="campaign-card__action__footer">
          <button className="campaign-button" onClick={toggleTriggerModal}>
            <span class="campaign-button__label">Edit</span>
          </button>
        </div>
      </div>
      <TriggerModal isOpen={triggerModal} onClose={toggleTriggerModal} cardData={cardData} />
    </>
  );
};

export default TriggerCard;
